<div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end bg-surface">
  <ng-content></ng-content>
</div>
